

import React , { useState } from "react";

import { useDatasCourtierCompagnies } from "../../../state/reactquery";


import AllCompagnys from "./AllCompagnys ";
import TabloOneCompagnie from "./TabloOneCompagnie";
import ContactsCompagnie from "./ContactsCompagnie";
import ValidationCompagnie from "./ValidationCompagnie";


import './Compagnys.scss' ;
const classNames = require('classnames');

function Compagnys(){
    const [selectedcompagnie, setSelectedcompagnie] = useState({}) ;
    const {data:datascourtiercompagnies}  = useDatasCourtierCompagnies() ; 

    const datascourtierselectedcompagnie = datascourtiercompagnies?.filter(c=>c?.compagnie_mini ===selectedcompagnie?.compagnie_mini)?.[0] ;
    const courtier_auth =   datascourtierselectedcompagnie?.courtier_auth; 
    const email_inspecteur =   datascourtierselectedcompagnie?.email_inspecteur; 
    const code_courtier =   datascourtierselectedcompagnie?.codecourtier; 
 
    const displayvalidationcompagnie =email_inspecteur && code_courtier &&  selectedcompagnie?.compagnie && (courtier_auth!=='ok' && courtier_auth!=='refused' && courtier_auth!=='wait' ) 
    const displautabloonecompagnie = selectedcompagnie?.id_compagnie && courtier_auth==='ok'  ;

    return( <><AllCompagnys selectedcompagnie={selectedcompagnie} setSelectedcompagnie={setSelectedcompagnie} />
                <ContactsCompagnie infoscompagnie={datascourtierselectedcompagnie} selectedcompagnie={selectedcompagnie} /> 
                { !displayvalidationcompagnie && <ValidationCompagnie infoscompagnie={datascourtierselectedcompagnie}  selectedcompagnie={selectedcompagnie}  />}
               {(courtier_auth && courtier_auth!=='no') && <><div className={`validationcompagnie_texte1 mb20 valid${courtier_auth}`}> Validation du partenariat</div>
                <div className={classNames("validationcompagnie_texte1 mb20",{'validok':courtier_auth==='ok'})}>Identifiants du web-service</div></>}
               
                {displautabloonecompagnie &&  <TabloOneCompagnie compagnie_mini={selectedcompagnie?.compagnie_mini} />       }
             </>);
}


export default Compagnys



